import styled from 'styled-components';

export const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 226px 226px;
    grid-column-gap: ${({ theme }) => theme.spacing * 5}px;
    @media screen and (max-width: 690px) {
        grid-template-columns: 100%;
        grid-template-rows: auto auto;
    }
`;

export const DovePointsInfo = styled.p`
    margin: ${({ theme }) => theme.spacing * -5}px 0 0;
    color: ${({ theme }) => theme.colors.darkBlueAlphaMedium};
    font-size: 10px;
    font-weight: bold;
    opacity: .87;
`;
